import { Navigate, Outlet } from "react-router-dom";

import type { CommandCenterSettingEnum } from "graphql_globals";
import { useActiveOrganizationSettings } from "common/account/active_organization";

// Expects to be used under an ActiveOrganizationProvider context
export function CommandCenterVersionRedirect({
  expectedVersion,
  failureNavigateRoute,
}: {
  expectedVersion: CommandCenterSettingEnum;
  failureNavigateRoute: string;
}) {
  if (expectedVersion !== useActiveOrganizationSettings().commandCenterEnabledValue) {
    return <Navigate to={failureNavigateRoute} replace />;
  }

  return <Outlet />;
}
